export function getLetter(index: number) {
    return String.fromCharCode(65 + index);
}